export default __webpack_public_path__ + "static/media/tweeter_icon.aa0e9e50.webp";